import React from 'react';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useLocation, useHistory } from 'react-router-dom';
import {Chip, emphasize} from "@mui/material"
import {makeStyles,withStyles} from "@mui/styles"
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
const useStyles = makeStyles((theme) => ({
    root: {
        '& > * + *': {
            marginTop: theme.spacing(4),
            marginLeft: theme.spacing(5),
            marginRight: theme.spacing(5),

        },
        height:30,
        width:'90%',
       // paddingTop:9,
       // paddingBottom:7,
        marginTop: '1.5%',//theme.spacing(7),
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5),
        //backgroundColor:'blue'  ,
        fontFamily: 'roboto'
    },
}));




const AppBreadcrumbs = () => {

    const StyledBreadcrumb = withStyles((theme) => ({
        root: {
            backgroundColor: theme.palette.grey[100],
            height: theme.spacing(3),
            color: theme.palette.grey[800],
            fontWeight: theme.typography.fontWeightRegular,
            '&:hover, &:focus': {
                backgroundColor: theme.palette.grey[300],
            },
            '&:active': {
                boxShadow: theme.shadows[1],
                backgroundColor: emphasize(theme.palette.grey[300], 0.12),
            },
        },
    }))(Chip);

    let navigate = useHistory();
    let location = useLocation();
    const classes = useStyles();

const redirectTo=(path)=>{
const {pathname}=location;
    if(pathname.includes(path)){
      let routes = pathname.split('/');
       let pathnew = ""

       for (let index = 0; index < routes.length; index++) {
           const element = routes[index];
           if(!pathnew.includes(path) && element!=='/'){
             
            if(pathnew.endsWith('/'))
            pathnew = pathnew + element;
            else
            pathnew =  pathnew +'/'+ element
           }
       }
       navigate.push(pathnew)
        //window.location.href = pathnew;
    } 
         else
         navigate.push(path)
 }

    let currentRoutes = []
    currentRoutes = location.pathname !== '/' ? location.pathname.split('/') : ['Home'];
    if (currentRoutes.length > 0) {
        currentRoutes.shift();
        return (
            <div className={classes.root}>
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb" style={{ marginBottom: 15 }}>

                    <StyledBreadcrumb
                        component="a"
                        label="Home"
                        icon={<HomeIcon fontSize="small" />}
                        onClick={() => navigate.push('/')}
                    />
                    {
                        currentRoutes.length === 1
                            ? <StyledBreadcrumb /* color="textPrimary" */ label={currentRoutes[0]}/> 
                            : currentRoutes.map((route, index) => {
                                
                                return (index !== currentRoutes.length - 1?   <StyledBreadcrumb  key={index} component="a" 
                                 label={route} /* onClick={() => redirectTo(route)} */ /> : <StyledBreadcrumb key={index}  label={route}/* color="textPrimary" *//>)
                                   
                            })
                    }
                </Breadcrumbs></div>
        );
    }
    else
        return <></>



}

export default AppBreadcrumbs;